// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step4PddCom[data-v-02de6ab6] .el-tabs__item {\n  height: 46px;\n  line-height: 46px;\n}\n.step4PddCom[data-v-02de6ab6] .el-select {\n  flex: 1;\n}\n.step4PddCom .tab-header[data-v-02de6ab6] {\n  display: flex;\n  padding: 16px 75px 32px;\n  justify-content: center;\n}\n.step4PddCom .tab-bottom[data-v-02de6ab6] {\n  padding: 0 40px;\n}\n.icon-company-box[data-v-02de6ab6] {\n  width: 35px;\n  height: 35px;\n}\n", ""]);
// Exports
module.exports = exports;
